'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/Button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Esse log aparecerá na aba "Logs" da Vercel em tempo real
    console.error('ERRO GLOBAL CAPTURADO NO STUDIO:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-xl text-center bg-background">
      <div className="animate-fade-in space-y-xl">
        <div className="space-y-md">
          <h2 className="font-playfair text-4xl text-primary leading-tight">
            Algo não saiu como planejado.
          </h2>
          <p className="text-secondary mx-auto leading-relaxed">
            Ocorreu um erro inesperado. O sistema já registrou o incidente para análise.
          </p>
        </div>
        
        <div className="flex gap-md justify-center">
          <Button onClick={() => reset()} className="px-xl">Tentar Novamente</Button>
          <Button variant="outline" onClick={() => window.location.href = '/dashboard'} className="px-xl">Ir para o Painel</Button>
        </div>

        {process.env.NODE_ENV !== 'production' && (
          <div className="mt-xl p-md bg-error/5 text-error text-left overflow-auto max-w-2xl mx-auto rounded-lg border border-error/10 text-xs font-mono">
            <strong>Stack Trace (Visível apenas em Dev/Preview):</strong>
            <pre className="mt-sm whitespace-pre-wrap">{error.stack}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
